import { Subject } from 'rxjs';
import { DeferredData, Rpc } from '../rpc';
import { RpcSubjectServer } from '../rpc-subject-server';
import { RpcSmeExtensionRequest, RpcSmeExtensionRequestKey } from './rpc-sme-extension-model';
import { RpcSmeExtensionRequestHandler } from './rpc-sme-extension-request-handler';

/**
 * Rpc extension subject interface.
 */
export interface RpcSmeExtensionSubject extends Subject<DeferredData<RpcSmeExtensionRequest, void>> {}

/**
 * The class to implement Rpc extension with Subject server.
 */
export class RpcSmeExtensionSubjectServer
        extends RpcSubjectServer<RpcSmeExtensionRequest, void>
        implements RpcSmeExtensionRequestHandler {

    /**
     * Initializes a new instance of the RpcSmeExtensionSubjectServer class.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcSmeExtensionRequestKey.command);
    }

    /**
     * The handler to respond a request for Rpc extension call.
     *
     * @param data The extension object.
     * @returns return the Promise<void> object.
     */
    public handler(data: RpcSmeExtensionRequest): Promise<void> {
        return this.processNextForSubject(RpcSmeExtensionRequestKey.command, data);
    }
}
